import { Actions, createNamespace } from "../../../flux/Actions";
import { GetTimezonesFn } from "../../../rest/Misc/timezones";

const ns = createNamespace('TIMEZONE');
export const names = {
    SET_TIMEZONES: ns('SET_TIMEZONES'),
};

// TimezoneActions pulls list of Timezones from server
// TimezoneActions is an Action in terms of Flux
export class TimezoneActions extends Actions
{
    private timerId;
    
    constructor(private getTimezones: GetTimezonesFn)
    {
        super();
    }

    startPullingTimezones = (msInterval: number): void => {
        this.pullTimezones();
        this.timerId = setInterval(this.pullTimezones, msInterval);
    };

    stopPullingTimezones = (): void => {
        clearInterval(this.timerId);
        this.timerId = null;
    };

    pullTimezones = (): void => {
        this.getTimezones()
            .then(tzr => this.dispatch(names.SET_TIMEZONES, tzr.Timezones));
    };
}


// WEBPACK FOOTER //
// ./src/app/utils/TimeZone/TimezoneActions.ts